// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"a8008c80","138":"a8008c80","341":"a8008c80","396":"a8008c80","582":"a8008c80","823":"a8008c80","867":"a8008c80"}[chunkId] + ".chunk.css";
};